<template>
    <div>
        <div class="upload-dropdown__container">
            <dropdown
                    v-if="Object.keys(managerList).length > 1 && !isPreloader"
                    title="Менеджеры"
                    :items="managerList"
                    :selectedItems="selectedUser"
                    :isManyItems="false"
                    :width="'220px'"
                    :height="'44px'"
                    :prompt="'Выберите значение'"
                    @onChange="onChangeManager($event)"
            />
            <dropdown
                    v-if="!isPreloader && selectedYear"
                    title="Год"
                    :items="getYearList()"
                    :selectedItems="selectedYear"
                    :isManyItems="false"
                    :width="'220px'"
                    :height="'44px'"
                    :prompt="'Выберите значение'"
                    @onChange="onChangeYear($event)"
            />
        </div>
        <form-import
            :validateTypes="validateTypes"
            :isPreloader="isPreloader"
            @onClickSubmit="onClickSubmit"
            @onClickUploadLastSlice = "onClickUploadLastSlice"
        />
    </div>
</template>

<script>
import FormImport from '../../components/Forms/FormImport';
import serviceApi from "../../services/serviceApi";
import schemeApi from "../../schemes/schemeApi";
import Dropdown from "../../components/Base/Dropdown";
import {mapState} from "vuex";
let {routeCopyLastSlice, routeClientManagers} = schemeApi;
export default {
    name: 'ViewImportAttach',
    components: {
        FormImport,
        Dropdown
    },
    /**
     * входные данные компонента
     * @property {boolean} isPreloader - условие показа прелоадера
     */
    props: {
        isPreloader: {
            type: Boolean,
            default: false
        }
    },
    /**
     * Данные компонента
     * @property {array} validateTypes - допустимые типы файлов для формы импорта
     * @property {array} managerList - список менеджеров для выпадашки
     * @property {Boolean} globalView - Флаг доступа к списку менеджеров
     * @property {array} selectedUser - выбранный пользователь
     */
    data: () => ({
        validateTypes: [
            'application/vnd.ms-excel', 
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ],
        managerList: {},
        globalView: false,
        selectedUser: [],
        selectedYear: []
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    mounted() {
        var now = new Date();
        this.selectedYear.push(String(now.getFullYear()));
        // this.globalView = serviceAuth.checkPermission(this.activeProjectId, 'global_view');
        // if(this.globalView){
        this.getManagers();
        // }
    },
    methods: {
        /**
         * Событие выбора менеджера
         * @property {array} data - id выбранного пользователя
         */
        onChangeManager(data){
            this.selectedUser = data;
        },
        /**
         * Событие выбора года
         * @property {array} data - выбранный год
         */
        onChangeYear(data){
            this.selectedYear = data;
        },
        /**
         * Получение значений годов для выпадашки
         */
        getYearList(){
            var now = new Date();
            var cur_year = now.getFullYear();
            let years = {};
            years[String(cur_year - 2)] = String(cur_year - 2);
            years[String(cur_year - 1)] = String(cur_year - 1);
            years[String(cur_year)] = String(cur_year);
            years[String(cur_year + 1)] = String(cur_year + 1);
            return years
        },
        /**
         * событие отправки формы
         * @param {object} data - данные формы
         * @param {boolean} isNotClear
         */
        onClickSubmit(data, isNotClear) {
            data.append('selectedUser', this.selectedUser);
            data.append('selectedYear', this.selectedYear);
            this.$emit('onClickSubmit', data, isNotClear);
        },
        /**
         * создать срез
         * @async
         */
        async onClickUploadLastSlice() {
            let isСonfir = confirm('Вы уверены что хотите взять данные из последнего среза?');
            if (isСonfir) {
                try {
                    let {data = {}} = await serviceApi.post(routeCopyLastSlice, {selectedUser: this.selectedUser, selectedYear: this.selectedYear});
                    let {message = null} = data;
                    if (message !== null)
                        alert(message);
                }
                catch(error) {
                    if (error.message === 'not server')
                        alert('Извините, сервер временно недоступен');
                }
            }
        },
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getManagers() {
            try {
                let result = await serviceApi.post(routeClientManagers);
                let {list = {}, selected = []} = result.data;
                this.managerList = list;
                this.selectedUser = selected;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .upload-dropdown__container {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
    }
</style>